import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

export const CountriesList = ({ countries = [], onSelect }) => (
    <div className="map-menu-wrapper">
        <div className="map-menu-first">Countries - {countries.length}</div>
        <ul className="map-menu--countires">
            {countries.map((country, index) => (
                <li key={index} onClick={() => onSelect(country)}>
                    <div>
                        <span>{country}</span>
                    </div>
                </li>
            ))}
        </ul>

        <div className="map-menu-last">
            <Link
                to="/modern-slavery"
                title="Modern Slavery"
                className="fg-yellow invert modern-slavery-cities"
            >
                <i />
                <span>Modern Slavery</span>
            </Link>
        </div>
    </div>
);

CountriesList.props = {
    countries: PropTypes.array.isRequired,
    onSelect: PropTypes.func,
};
